/**
 * @generated SignedSource<<d2f61503af9588d389936ea9e41e3687>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeletePopupInput = {
  clientMutationId?: string | null;
  popupId: string;
};
export type PopupPatternTableActions_DeleteMutation$variables = {
  input: DeletePopupInput;
  connections: ReadonlyArray<string>;
};
export type PopupPatternTableActions_DeleteMutationVariables = PopupPatternTableActions_DeleteMutation$variables;
export type PopupPatternTableActions_DeleteMutation$data = {
  readonly deletePopup: {
    readonly deletedPopupId: string;
  } | null;
};
export type PopupPatternTableActions_DeleteMutationResponse = PopupPatternTableActions_DeleteMutation$data;
export type PopupPatternTableActions_DeleteMutation = {
  variables: PopupPatternTableActions_DeleteMutationVariables;
  response: PopupPatternTableActions_DeleteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedPopupId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PopupPatternTableActions_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DeletePopupPayload",
        "kind": "LinkedField",
        "name": "deletePopup",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PopupPatternTableActions_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DeletePopupPayload",
        "kind": "LinkedField",
        "name": "deletePopup",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedPopupId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a5595b29d94e4c0e3a98e8b0d2cee508",
    "id": null,
    "metadata": {},
    "name": "PopupPatternTableActions_DeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PopupPatternTableActions_DeleteMutation(\n  $input: DeletePopupInput!\n) {\n  deletePopup(input: $input) {\n    deletedPopupId\n  }\n}\n"
  }
};
})();

(node as any).hash = "08d3e38b327d52c4de4db9901f877f74";

export default node;
